import { type Category } from '@scayle/storefront-nuxt'
import { getCategoryBreadcrumbs } from '#layers/base/utils/breadcrumb'

export default ({
  selectedCategory,
  categories,
}: {
  selectedCategory: Ref<Category>
  categories: Ref<Category[]>
}) => {
  const allCategories = computed(() =>
    Array.isArray(categories.value) ? categories.value[0] : categories.value,
  )

  // ECOM-2384: build breadcrumb links from the shared cmsPagePath-aware rule so
  // a category replaced by a content page links to that page (matching nav),
  // instead of Scayle's getBreadcrumbsFromCategory which always uses category.path.
  const breadcrumbs = computed(() =>
    allCategories.value
      ? getCategoryBreadcrumbs(allCategories.value, selectedCategory.value)
      : undefined,
  )

  return { breadcrumbs }
}
